export default __webpack_public_path__ + "static/media/gameplay-icon-8.c83346fd.gif";